import type { WalletBlockProps } from "./types";

export function WalletWeb(props: WalletBlockProps) {
  void props;
  return null;
  // return (
  //   <EmailComponentWrapper shop={props.shop}>
  //     <WalletEmailRenderer {...props} />
  //   </EmailComponentWrapper>
  // );
}
